import { render, staticRenderFns } from "./PrefabricatedText.vue?vue&type=template&id=2c517f8b&"
import script from "./PrefabricatedText.vue?vue&type=script&lang=js&"
export * from "./PrefabricatedText.vue?vue&type=script&lang=js&"
import style0 from "./PrefabricatedText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrefabricatedText.vue"
export default component.exports